/**
 * P-19a item 8 — D-146 (Q-95): the "שיחות" page is removed. It only showed the
 * chats of tickets and discussions in another form; every message stays in its
 * ticket's / discussion's conversation. Old links (/conversations…) land here:
 *
 *   ?ticket=<id>                     → that ticket's / discussion's chat (/tickets/<id>?tab=chat)
 *   ?filter=discussion               → "דיונים" (/discussions)
 *   ?filter=unread | awaiting_reply  → "קריאות אליי", open (/tickets?scope=to_me&active=true)
 *   anything else                    → "קריאות" (/tickets)
 *
 * Pure; unit-tested in src/utils/__tests__/conversationsRedirect.test.ts.
 */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function conversationsRedirect(search: string): string {
  const sp = new URLSearchParams(search);
  const ticket = sp.get('ticket') || '';
  if (UUID_RE.test(ticket)) return `/tickets/${ticket}?tab=chat`;
  const filter = sp.get('filter');
  if (filter === 'discussion') return '/discussions';
  if (filter === 'unread' || filter === 'awaiting_reply') return '/tickets?scope=to_me&active=true';
  return '/tickets';
}

/** A chat link: the ticket / discussion page opens on its conversation. */
export const chatLink = (ticketId: string): string => `/tickets/${ticketId}?tab=chat`;
